// =============================================================================
// Shop.tsx — Chip and cosmetic shop screen
// Project: Texas Hold'em Social Casino
// =============================================================================
// Lists available purchase options. Integrates with Stripe on standalone
// or LINE Pay when embedded in LINE. Shows platform-appropriate pricing.

import React, { useEffect, useState } from 'react'
import { useUIStore } from '../store/ui-store'
import { usePlayerStore } from '../store/player-store'
import { PurchaseOption } from '../types'

const API_BASE = import.meta.env.VITE_API_URL || '/api'

export default function ShopScreen(): React.ReactElement {
  const { navigateTo, showToast } = useUIStore()
  const { refreshProfile } = usePlayerStore()
  const [options, setOptions] = useState<PurchaseOption[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchOptions = async (): Promise<void> => {
      try {
        const res = await fetch(`${API_BASE}/purchase/options`)
        const json = await res.json()
        if (json.success) {
          setOptions(json.data || [])
        }
      } catch (err) {
        console.error('Failed to fetch purchase options:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchOptions()
  }, [])

  const handlePurchase = (option: PurchaseOption): void => {
    // TODO: Implement Stripe/LINE Pay integration
    showToast(`Purchasing ${option.label}...`, 'info')
  }

  return (
    <div className="lobby">
      <div className="lobby-header">
        <button className="btn btn-secondary" style={{ padding: '6px 14px', fontSize: 12 }} onClick={() => navigateTo('lobby')}>
          ← Back
        </button>
        <div className="lobby-title">Shop</div>
        <div style={{ width: 60 }} />
      </div>

      <div style={{ marginTop: 16 }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Buy Chips</div>

        {loading ? (
          <div className="flex-center" style={{ padding: 40, color: '#666' }}>Loading...</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {options.map(option => (
              <div key={option.sku} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                background: 'rgba(255,255,255,0.05)', borderRadius: 12,
                padding: '14px 16px', border: '1px solid rgba(255,255,255,0.08)',
              }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{option.label}</div>
                  {option.bonusChips > 0 && (
                    <div style={{ fontSize: 12, color: '#4caf50' }}>
                      +{option.bonusChips.toLocaleString()} bonus!
                    </div>
                  )}
                </div>
                <button className="btn btn-gold" onClick={() => handlePurchase(option)}>
                  ${option.priceUsd.toFixed(2)}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
